import React from 'react';
import { createPortal } from 'react-dom';

type Props = {
  style?: React.CSSProperties;
  className?: string;
  onIframeRendered?: (iframe: HTMLIFrameElement) => void;
  children:
    | React.ReactElement<any>
    | ((iframe: HTMLIFrameElement) => React.ReactElement<any>);
  onError?: (reason: string) => void;
};

export const IFramePortal: React.FC<Props> = (props) => {
  const [iframe, setIframe] = React.useState<HTMLIFrameElement>();

  const handleIframeRef = (iframe: HTMLIFrameElement) => {
    setIframe(iframe);
  };

  React.useEffect(() => {
    if (props.onIframeRendered && iframe) {
      props.onIframeRendered(iframe);
    }
  }, [iframe]);

  return (
    <>
      <iframe
        style={props.style}
        className={props.className}
        ref={handleIframeRef}
      />
      {iframe?.contentWindow && iframe?.contentDocument
        ? createPortal(
            typeof props.children === 'function'
              ? props.children(iframe)
              : props.children,
            iframe?.contentDocument?.body
          )
        : null}
    </>
  );
};
